import { createContext, useContext } from 'react';

import { METER_BAR_SIZE } from '../constants.js';
import type { MeterBarSize } from '../types/meter-bars.js';

export type MeterBarLayoutSizeProps = {
  /**
   * The size that applies to the value, icon, and label.
   * @defaultvalue 'size16'
   */
  size: MeterBarSize;
  chartHeight: number;
  chartWidth: number;
  segmentWidth: number;
  segmentHeight: number;
};

export const MeterBarLayoutSizeContext = createContext<MeterBarLayoutSizeProps>(
  {
    size: METER_BAR_SIZE.Size16,
    chartWidth: 0,
    chartHeight: 0,
    segmentWidth: 0,
    segmentHeight: 0,
  },
);

export const useMeterBarLayoutSize = () =>
  useContext(MeterBarLayoutSizeContext);

useMeterBarLayoutSize['displayName'] = 'useMeterBarLayoutSize';
MeterBarLayoutSizeContext['displayName'] = 'MeterBarLayoutSizeContext';
